import { render, staticRenderFns } from "./InvoiceConcepts.vue?vue&type=template&id=1318f95a&scoped=true&"
import script from "./InvoiceConcepts.vue?vue&type=script&lang=js&"
export * from "./InvoiceConcepts.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceConcepts.vue?vue&type=style&index=0&id=1318f95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318f95a",
  null
  
)

export default component.exports